import { motion } from "framer-motion";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

interface ViewsCardProps {
  platforms: string[];
  values: number[];
  colors: string[];
}

export default function ViewsCard({
  platforms,
  values,
  colors,
}: ViewsCardProps) {
  const barStyles = colors.reduce<Record<string, { fill: string }>>(
    (styles, color, index) => {
      styles[`& .MuiBarElement-root:nth-of-type(${index + 1})`] = {
        fill: color,
      };
      return styles;
    },
    {},
  );

  const isEmpty =
    platforms.length === 0 || values.every((value) => value === 0);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.15, ease: [0.4, 0, 0.2, 1] }}
    >
      <Card sx={{ height: "100%", borderRadius: 3, boxShadow: 0 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
            Views
          </Typography>
          {isEmpty ? (
            <Box
              sx={{
                height: 190,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                No platform report
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{ height: 190, display: "flex", justifyContent: "center" }}
            >
              <BarChart
                xAxis={[
                  {
                    data: platforms,
                    scaleType: "band",
                    disableLine: true,
                    disableTicks: true,
                    label: "",
                  },
                ]}
                series={[{ data: values }]}
                yAxis={[
                  {
                    tickLabelStyle: { display: "none" },
                    disableLine: true,
                    disableTicks: true,
                  },
                ]}
                width={200}
                height={190}
                margin={{ left: 0, right: 0, top: 10, bottom: 30 }}
                grid={{ horizontal: false }}
                sx={{
                  "& .MuiChartsAxis-line": { display: "none" },
                  "& .MuiBarElement-root": { rx: 30, ry: 30 },
                  ...barStyles,
                }}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}
